import {SET_REQUEST_CHECKBOX_VALUE} from "../../enums/Employees/employees.types";

export const setRequestCheckBoxAction = (data) => {
    return {
        type: SET_REQUEST_CHECKBOX_VALUE,
        payload: data,
    };
};
